<template>
    <CCard>
      <CCardHeader>
        {{ $t('Users') }}
        <div class="card-header-actions">
          <CButton
            color="primary"
            v-if="isAdministrator"
            :to="{ name: 'User', params: { id: 'new' } }"
          >
            <i class="fa fa-plus" />
            {{ $t("Create") }}
          </CButton>
        </div>
      </CCardHeader>

      <CCardBody>
        <tableComponent
            :columns="['firstname', 'lastname', 'email', 'created_at', 'role', 'actions']"
            :url="USER_ENDPOINTS.list"
            :filter-exclude-columns="['created_at', 'actions']"
            :table-override-filters="tableOverrideFilters"
            ref="table"
            v-if="roles.length"
        >
          <template slot="firstname" slot-scope="{ row }">
            {{ row.firstname || '' }}
          </template>
          <template slot="lastname" slot-scope="{ row }">
            {{ row.lastname || '' }}
          </template>
          <template slot="role" slot-scope="{ row }">
            <span class="text-capitalize">
              {{ row.role }}
            </span>
          </template>
          <div slot="actions" slot-scope="{ row }" class="d-flex gap-1">
            <CButton
              :to="{ name: 'User', params: { id: row.id } }"
              color="primary"
              variant="outline"
              v-c-tooltip="$t('Details about user')"
            >
              <i class="fa fa-search-plus" />
            </CButton>
            <CButton
              :to="{ name: 'User', params: { id: row.id }, query: { edit: 1 } }"
              color="primary"
              variant="outline"
              v-c-tooltip="$t('Edit user')"
              v-if="isAdministrator"
            >
              <i class="fa fa-edit" />
            </CButton>
            <CButton
              @click="() => deleteUser(row)"
              color="danger"
              variant="outline"
              v-c-tooltip="$t('Delete user')"
              v-if="isAdministrator"
            >
              <i class="fa fa-trash-o" />
            </CButton>
          </div>
        </tableComponent>
      </CCardBody>
    </CCard>
</template>

<script>
import { freeSet } from '@coreui/icons';
import { USER_ENDPOINTS, users } from '@/services/users';
import { ActiveUser } from '@/services/user';

export default {
  name: 'users',
  freeSet,
  props: {},
  data() {
    return {
      USER_ENDPOINTS,
      isAdministrator: ActiveUser.isAdministrator(),
      roles: [],
    };
  },
  mounted() {
    this.fetchRoles();
  },
  computed: {
    tableOverrideFilters() {
      return {
        role: {
          options: this.roles.map((option) => ({
            label: this.$capitalize(option),
            value: option,
          })),
        },
      };
    },
  },
  methods: {
    async fetchRoles() {
      this.roles = await users.getRoles();
    },
    async deleteUser(user) {
      if (!await confirm(this.$t('user_delete', { email: user.email }))) {
        return;
      }
      try {
        await users.deleteUser(user.id);
      } catch (e) {
      }
      this.$refs.table.$refs.table.getData();
    },
  },
};
</script>
